import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import store from '../store';
import EmployeeApplyForAdmin from './EmployeeApplyForAdmin';
import AdminReview from './AdminReview';

const AdminDashboard = observer(() => {
  const [activeTab, setActiveTab] = useState(0);

  // 初始化数据
  useEffect(() => {
    // 加载我的申请数据
    store.fetchbx('mine');
    // 加载所有审核数据
    store.fetchAdminBx();
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Tabs value={activeTab} onChange={handleTabChange} centered>
          <Tab label="申请报销" />
          <Tab label="审核报销" />
        </Tabs>
      </Paper>
      
      {activeTab === 0 && <EmployeeApplyForAdmin />}
      {activeTab === 1 && <AdminReview />}
    </Box>
  );
});

export default AdminDashboard;
